"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    Table = function Table(r) {
  return React.createElement("table", {
    style: r.style,
    className: "blx-table " + r.className
  }, React.createElement("thead", null, React.createElement("tr", {
    className: "blx-table-header-row"
  }, r.headings.map(function (e) {
    return React.createElement("th", {
      className: "blx-table-header-cell",
      key: e
    }, e);
  }))), React.createElement("tbody", null, r.entries.map(function (a, l) {
    return React.createElement("tr", {
      className: "blx-table-row",
      key: "table-row-" + l,
      onClick: function onClick() {
        r.onClick(a);
      }
    }, r.headings.map(function (e, t) {
      return React.createElement("td", {
        className: "blx-table-cell " + ("number" == typeof a[e] ? "numeric" : ""),
        key: r.tableName + "-row-" + l + "-column-" + t
      }, a[e]);
    }));
  })));
};

Table.propTypes = {
  tableName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  headings: PropTypes.arrayOf(PropTypes.string),
  entries: PropTypes.array,
  onClick: PropTypes.func
}, Table.defaultProps = {
  tableName: "table",
  className: "",
  style: null,
  headings: [],
  entries: [],
  onClick: function onClick() {}
}, module.exports = Table;